(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    // Carrusel de sugeridos del carrito. Flechas, puntos y sincronizacion
  // al deslizar. El drawer se repinta con la Section Rendering API, asi que
  // volvemos a enganchar todo cada vez que cambia el carrito.
  function dnInitCartCarousel(root) {
    var scope = root && root.nodeType === 1 ? root : document;
    var widgets = [];
    if (scope.nodeType === 1 && scope.matches && scope.matches('[data-dn-cs]')) widgets.push(scope);
    Array.prototype.push.apply(widgets, scope.querySelectorAll('[data-dn-cs]'));

    widgets.forEach(function (widget) {
      if (widget.dataset.dnCsInit === 'true') return;
      widget.dataset.dnCsInit = 'true';

      var track = widget.querySelector('[data-dn-cs-track]');
      var slides = widget.querySelectorAll('[data-dn-cs-slide]');
      var navs = widget.querySelectorAll('[data-dn-cs-nav]');
      var dotsWrap = widget.querySelector('[data-dn-cs-dots]');
      if (!track || slides.length < 2) return;

      Array.prototype.forEach.call(navs, function (b) { b.hidden = false; });

      if (dotsWrap) {
        dotsWrap.hidden = false;
        dotsWrap.textContent = '';
        for (var i = 0; i < slides.length; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'dn-cart__cs-dot' + (i === 0 ? ' is-active' : '');
          dot.dataset.index = i;
          dot.setAttribute('aria-label', 'Go to item ' + (i + 1));
          dotsWrap.appendChild(dot);
        }
      }

      function current() {
        return Math.round(track.scrollLeft / track.clientWidth);
      }

      function sync() {
        var index = current();
        if (dotsWrap) {
          Array.prototype.forEach.call(dotsWrap.children, function (d, i) {
            d.classList.toggle('is-active', i === index);
          });
        }
        Array.prototype.forEach.call(navs, function (b) {
          var dir = parseInt(b.dataset.dnCsNav, 10) || 1;
          b.disabled = dir < 0 ? index <= 0 : index >= slides.length - 1;
        });
      }

      Array.prototype.forEach.call(navs, function (b) {
        b.addEventListener('click', function () {
          var dir = parseInt(b.dataset.dnCsNav, 10) || 1;
          track.scrollBy({ left: track.clientWidth * dir, behavior: 'smooth' });
        });
      });

      if (dotsWrap) {
        dotsWrap.addEventListener('click', function (event) {
          var dot = event.target.closest('.dn-cart__cs-dot');
          if (!dot) return;
          var i = parseInt(dot.dataset.index, 10) || 0;
          track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
        });
      }

      track.addEventListener('scroll', sync, { passive: true });
      sync();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { dnInitCartCarousel(document); });
  } else {
    dnInitCartCarousel(document);
  }

  document.addEventListener('shopify:section:load', function (event) { dnInitCartCarousel(event.target); });
  document.addEventListener('cart:update', function () {
    window.setTimeout(function () { dnInitCartCarousel(document); }, 0);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dingnest-bundle"] && !Shopify.designMode) return;
  try {
    // Replica el formato de moneda de la tienda. Los marcadores se construyen por
  // concatenacion a proposito: dentro de un bloque javascript no se puede
  // escribir la sintaxis de Liquid, ni siquiera dentro de una cadena.
  function dnBundleMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var groupedComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var groupedDot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var out = format || '';

    if (!out) return groupedComma + '.' + parts[1];

    function sub(name, replacement) {
      out = out.replace(new RegExp('\\{\\{\\s*' + name + '\\s*\\}\\}', 'g'), replacement);
    }

    sub('amount_no_decimals_with_comma_separator', groupedDot);
    sub('amount_with_comma_separator', groupedDot + ',' + parts[1]);
    sub('amount_no_decimals', groupedComma);
    sub('amount', groupedComma + '.' + parts[1]);
    return out;
  }

  function dnInitBundle(root) {
    var scope = root && root.nodeType === 1 ? root : document;
    var found = [];
    if (scope.nodeType === 1 && scope.matches && scope.matches('[data-dn-bundle]')) found.push(scope);
    Array.prototype.push.apply(found, scope.querySelectorAll('[data-dn-bundle]'));

    found.forEach(function (widget) {
      if (widget.dataset.dnBundleInit === 'true') return;
      widget.dataset.dnBundleInit = 'true';

      var format = widget.dataset.moneyFormat || '';
      var tiers = Array.prototype.slice.call(widget.querySelectorAll('[data-dn-tier]'));
      var addons = Array.prototype.slice.call(widget.querySelectorAll('[data-dn-addon]'));
      var button = widget.querySelector('[data-dn-bundle-add]');
      var ctaText = widget.querySelector('[data-dn-bundle-cta-text]');
      var errorBox = widget.querySelector('[data-dn-bundle-error]');

      function currentTier() {
        for (var i = 0; i < tiers.length; i++) if (tiers[i].checked) return tiers[i];
        return tiers[0] || null;
      }

      function setText(sel, value) {
        var el = widget.querySelector(sel);
        if (el) el.textContent = value;
      }

      function toggle(sel, show) {
        var el = widget.querySelector(sel);
        if (el) el.hidden = !show;
      }

      function refresh() {
        var tier = currentTier();
        var qty = tier ? parseInt(tier.dataset.qty, 10) || 1 : 1;
        var total = tier ? parseInt(tier.dataset.total, 10) || 0 : 0;
        var compare = tier ? parseInt(tier.dataset.compare, 10) || 0 : 0;

        addons.forEach(function (a) {
          if (!a.checked) return;
          total += parseInt(a.dataset.price, 10) || 0;
          compare += parseInt(a.dataset.compare, 10) || 0;
        });

        var saved = compare - total;

        setText('[data-dn-bundle-title-qty]', qty);
        setText('[data-dn-bundle-title-price]', dnBundleMoney(total, format));
        setText('[data-dn-bundle-total]', dnBundleMoney(total, format));
        setText('[data-dn-bundle-compare]', dnBundleMoney(compare, format));
        setText('[data-dn-bundle-total-compare]', dnBundleMoney(compare, format));

        if (saved > 0) {
          var pct = Math.round((saved / compare) * 100);
          var label = 'Save ' + dnBundleMoney(saved, format) + ' (' + pct + '% off)';
          setText('[data-dn-bundle-save]', label);
          setText('[data-dn-bundle-total-save]', label);
        }

        toggle('[data-dn-bundle-savings]', saved > 0);
        toggle('[data-dn-bundle-total-compare]', saved > 0);
        toggle('[data-dn-bundle-total-save]', saved > 0);

        if (ctaText && button) {
          ctaText.textContent = (button.dataset.label || 'Add to cart') + ' - ' + dnBundleMoney(total, format);
        }
      }

      tiers.concat(addons).forEach(function (input) {
        input.addEventListener('change', refresh);
      });
      refresh();

      if (!button) return;

      button.addEventListener('click', function () {
        var tier = currentTier();
        var qty = tier ? parseInt(tier.dataset.qty, 10) || 1 : 1;
        var items = [{ id: button.dataset.variantId, quantity: qty }];

        addons.forEach(function (a) {
          if (a.checked) items.push({ id: a.dataset.variantId, quantity: 1 });
        });

        // El codigo del tramo manda sobre el general del bloque.
        var code = (tier && tier.dataset.tierCode) || widget.dataset.discountCode || '';

        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        if (errorBox) errorBox.hidden = true;

        var url = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add';

        fetch(url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) {
            return r.json().then(function (data) {
              if (!r.ok) throw new Error(data.description || data.message || 'Add to cart failed');
              return data;
            });
          })
          .then(function () {
            if (code) {
              // Aplica el codigo al carrito y vuelve al carrito ya con el descuento.
              window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
              return;
            }

            var cartItems = document.querySelector('cart-items-component');
            if (cartItems && typeof cartItems.fetchCartData === 'function') cartItems.fetchCartData();

            var drawer = document.getElementById('cart-drawer');
            if (drawer && typeof drawer.open === 'function') drawer.open();
            else window.location.href = '/cart';
          })
          .catch(function (err) {
            if (errorBox) {
              errorBox.textContent = err.message || 'Something went wrong. Please try again.';
              errorBox.hidden = false;
            }
          })
          .finally(function () {
            button.disabled = false;
            button.removeAttribute('aria-busy');
          });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { dnInitBundle(document); });
  } else {
    dnInitBundle(document);
  }

  document.addEventListener('shopify:section:load', function (event) { dnInitBundle(event.target); });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dingnest-countdown-js"] && !Shopify.designMode) return;
  try {
    class DingNestCountdown extends HTMLElement {
    connectedCallback() {
      var end = parseInt(this.dataset.end || '0', 10);
      if (!end) return;

      this.endMs = end * 1000;
      this.showDays = this.dataset.showDays === 'true';
      this.behavior = this.dataset.expiredBehavior || 'zeros';
      this.daily = this.dataset.mode === 'daily';
      this.DAY_MS = 86400000;

      this.live = this.querySelector('[data-pw-cd-live]');
      this.expiredEl = this.querySelector('[data-pw-cd-expired]');
      this.fields = {
        days: this.querySelector('[data-pw-cd-days]'),
        hours: this.querySelector('[data-pw-cd-hours]'),
        minutes: this.querySelector('[data-pw-cd-minutes]'),
        seconds: this.querySelector('[data-pw-cd-seconds]')
      };

      this.boundTick = this.tick.bind(this);
      this.onVisibility = function () {
        if (!document.hidden) this.boundTick();
      }.bind(this);

      this.tick();
      this.timer = window.setInterval(this.boundTick, 1000);
      document.addEventListener('visibilitychange', this.onVisibility);
    }

    disconnectedCallback() {
      if (this.timer) window.clearInterval(this.timer);
      if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
    }

    pad(value) {
      return value < 10 ? '0' + value : String(value);
    }

    set(field, value) {
      var el = this.fields[field];
      if (el && el.textContent !== value) el.textContent = value;
    }

    expire() {
      if (this.timer) window.clearInterval(this.timer);
      this.timer = null;

      if (this.behavior === 'hide') {
        this.hidden = true;
        return;
      }

      if (this.behavior === 'message' && this.expiredEl) {
        if (this.live) this.live.hidden = true;
        this.expiredEl.hidden = false;
      }
    }

    tick() {
      var now = Date.now();

      // Modo diario: al llegar a cero saltamos al reinicio siguiente.
      // El bucle cubre pestanas dormidas o paginas servidas desde cache.
      if (this.daily && this.endMs <= now) {
        var guard = 0;
        while (this.endMs <= now && guard < 400) {
          this.endMs += this.DAY_MS;
          guard++;
        }
      }

      var remaining = Math.floor((this.endMs - now) / 1000);

      if (remaining <= 0) {
        this.set('days', '00');
        this.set('hours', '00');
        this.set('minutes', '00');
        this.set('seconds', '00');
        this.expire();
        return;
      }

      var hours = Math.floor(remaining / 3600);
      var minutes = Math.floor((remaining % 3600) / 60);
      var seconds = remaining % 60;

      if (this.showDays) {
        var days = Math.floor(hours / 24);
        hours = hours % 24;
        this.set('days', this.pad(days));
      }

      this.set('hours', this.pad(hours));
      this.set('minutes', this.pad(minutes));
      this.set('seconds', this.pad(seconds));
    }
  }

  if (!customElements.get('dingnest-countdown')) {
    customElements.define('dingnest-countdown', DingNestCountdown);
  }
  } catch(e) { console.error(e); }
})();

})();
